// src/components/discussion/CommentLinks.jsx
import { useCallback } from "react";
import { Ic } from "../Icons";
import { ICONS } from "../iconsData";
import { fmtDT } from "../../utils/date";
import { useToast } from "../../context/ToastContext";
import { copyToClipboard } from "../../utils/clipboard";

/**
 * Режим «Ссылки» в обсуждении.
 *
 * Тонкое представление: получает готовый массив items (из collectLinks).
 * Одна и та же ссылка / email / путь, упомянутые несколько раз,
 * отображаются несколько раз - это разные упоминания. Дедупликации нет.
 *
 * Поведение по kind:
 *   - 'url'    - <a target="_blank" rel="noopener noreferrer">;
 *   - 'mailto' - <a href="mailto:…"> без target (почтовый клиент);
 *   - 'path'   - <button className="link"> с onClick: копирует путь
 *                в буфер обмена. Прямой переход по file:/// браузер
 *                блокирует, а n:\… - не URL.
 */
export default function CommentLinks({ items, getAuthor }) {
  const { showToast } = useToast();

  const handlePathClick = useCallback(
    async (path) => {
      const ok = await copyToClipboard(path);
      showToast(
        ok ? "Путь скопирован" : "Не удалось скопировать путь",
        ok ? "success" : "warning",
      );
    },
    [showToast],
  );

  if (items.length === 0) {
    return <div className="empty-note">В обсуждении пока нет ссылок</div>;
  }

  return (
    <div className="file-all-list">
      {items.map(({ comment, url, display, kind }, idx) => {
        const author = getAuthor(comment.authorId);
        const authorLabel = author ? `${author.last} ${author.first}` : "-";
        const isExternal = kind === "url";
        return (
          <div className="file-item" key={`${comment.id}-${idx}`}>
            <Ic d={ICONS.link} size={24} />
            <div className="file-info">
              <div className="file-name">
                {kind === "path" ? (
                  <button
                    type="button"
                    className="link"
                    onClick={() => handlePathClick(url)}
                    title="Скопировать путь"
                  >
                    {display}
                  </button>
                ) : (
                  <a
                    className="link"
                    href={url}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noopener noreferrer" : undefined}
                  >
                    {display}
                  </a>
                )}
              </div>
              <div className="file-meta">
                {authorLabel} · {fmtDT(comment.createdAt)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
